define('Mirasvit_LayeredNavigation/js/action/apply-filter-noajax-mode',[], function () {
    'use strict';

    return function (url) {
        window.location.href = url;
    };
});

